import { route } from 'ziggy';
import { Ziggy } from 'js@/ziggy.js';

export default function(name, params, absolute) {
    return route(name, params, absolute, Ziggy);
}



// modules.exports = function(name, params, absolute) {
//     return r(name, params, absolute, Ziggy);
// };
